import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as CatalogApi } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { firstValueFrom } from 'rxjs';
import { TranslationService } from './translation.service';

@Injectable({
	providedIn: 'root'
})
export class HelpdeskService {

	constructor(
		private catalogApi: CatalogApi,
		private translationService: TranslationService,
		private requestService: RequestService
	) { }

	async getHelpdeskContent(solution: string, helpId: string): Promise<string> {
		try {
			return firstValueFrom(this.catalogApi.common_GetHelpdeskContent(solution, helpId, this.translationService.getLanguage().toUpperCase()));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getHelpdeskTopicContent(solution: string, topicId: string): Promise<string> {
		try {
			return firstValueFrom(this.catalogApi.common_GetHelpdeskTopicContent(solution, topicId, this.translationService.getLanguage().toUpperCase()));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getHelpdeskRoute(solution: string, helpId: string): Promise<string> {
		try {
			return firstValueFrom(this.catalogApi.common_GetHelpdeskRoute(solution, helpId, this.translationService.getLanguage().toUpperCase()));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}


}
